import React, { useState, useEffect, Fragment } from 'react';
import {
  Button,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
} from 'reactstrap';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import { AxiosAPI } from '../../../../../helpers/AxiosAPI';
import { gAPI_Booking_By_Id, postAPI_ConfirmBooking, postAPI_CancelBooking } from '../../../../../constants/APIs';
import moment from 'moment';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
function BookingDetail({ bookingId, visible, toggle, BindData, locale }) {
  const [cancelVisible, setCancelVisible] = useState(false);
  const [bookingData, setBookingData] = useState({
    bookingId: '',
    referenceNumber: '',
    checkInDate: '',
    checkOutDate: '',
    adults: null,
    childrens: null,
    roomsUnits: null,
    currency: '',
    amountIncTax: null,
    amountExTax: null,
    comments: '',
    bookingStatus: '',
    paymentStatus: '',
    addOns: [],
    extras: [],
    promos: [],
    roomsRatePlans: [],
    guests: [],
    timeSlot: ''
  });
  useEffect(() => {
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_Booking_By_Id}/${bookingId}?languageCode=${locale}
`,
    })
      .then(res => {
        //console.log('res.data', res.data);
        // TODO:
        setBookingData(res.data);
        // setBookingData(DATA);
      })
      .catch(err => console.log('err', err));
  }, [bookingId]);

  const ConfirmBooking = () => {
    let data = {
      updator: "dashboard"
    };
    AxiosAPI({
      method: 'post',
      url: `${postAPI_ConfirmBooking}/${bookingId}`,
      data: data,
    })
      .then(data => {
        BindData();
        toggle();
      }
      )
      .catch(err => {
        console.log('err', err);
      });
  }

  const CancelBooking = () => {
    let data = {
      updator: "dashboard"
    };
    AxiosAPI({
      method: 'post',
      url: `${postAPI_CancelBooking}/${bookingId}`,
      data: data,
    })
      .then(data => {
        BindData();
        toggle();
      }
      )
      .catch(err => {
        console.log('err', err);
      });
  }

  const toggleCancelBooking = () => {
    setCancelVisible(!cancelVisible);
  };
  console.log(bookingData);
  const generateCancelBooking = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal isOpen={cancelVisible} toggle={toggle}>
                <ModalHeader toggle={toggle}>
                  <span role="img" aria-label="warning">
                    ⚠️
                  </span>
                  This booking will be cancel!
                </ModalHeader>
                <ModalBody>
                  <Button
                    color="danger"
                    onClick={() => CancelBooking()}
                    size="xs"
                  >
                    Cancel Booking
                  </Button>
                  <Button
                    className="ml-2"
                    color="dark"
                    outline
                    size="xs"
                    onClick={toggleCancelBooking}
                  >
                    Back
                  </Button>
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };


  return (

    <Modal isOpen={visible} toggle={() => toggle()} size="lg">
      <ModalHeader toggle={() => toggle()}>
        <div> Booking Detail</div>
      </ModalHeader>
      <ModalBody>
        <Row className="mb-3">

          <Colxx xxs={4} className="mb-3">
            <Label>Reference Number</Label>
            <div>{bookingData.referenceNumber}</div>
          </Colxx>
          {(bookingData.timeSlot == undefined || bookingData.timeSlot == null) &&
            <Fragment>
              <Colxx xxs={4} className="mb-3">
                <Label>Check In Date</Label>
                <div>{moment(bookingData.checkInDate).format('LL')}</div>
              </Colxx>
              <Colxx xxs={4} className="mb-3">
                <Label>Check Out Date</Label>
                <div>{moment(bookingData.checkOutDate).format('LL')}</div>
              </Colxx>

              <Colxx xxs={4} className="mb-3">
                <Label>Adults</Label>
                <div>{bookingData.adults}</div>
              </Colxx>
              <Colxx xxs={4} className="mb-3">
                <Label>Childrens</Label>
                <div>{bookingData.childrens}</div>
              </Colxx>
              <Colxx xxs={4} className="mb-3">
                <Label>No. of Units</Label>
                <div>{bookingData.roomsUnits}</div>
              </Colxx>
              <Colxx xxs={4} className="mb-3">
                <Label>Base Amount</Label>
                <div>
                  {bookingData.currency} {bookingData.baseAmount}
                </div>
              </Colxx>
              <Colxx xxs={4} className="mb-3">
                <Label>Extras</Label>
                <div>
                  {bookingData.currency} {bookingData.extrasAmount}
                </div>
              </Colxx>
              <Colxx xxs={4} className="mb-3">
                <Label>Discount</Label>
                <div>
                  {bookingData.currency} {bookingData.discountAmount}
                </div>
              </Colxx>
              <Colxx xxs={12} className="mb-3">
                <Label>Grand Total</Label>
                <div>
                  {bookingData.currency} {bookingData.grandTotal}
                </div>
              </Colxx>
            </Fragment>}
          {(bookingData.timeSlot !== undefined && bookingData.timeSlot !== null) &&
            <Colxx xxs={4} className="mb-3">
              <Label>Booking Date</Label>
              <div>{moment(bookingData.checkInDate).format('LL')}</div>
            </Colxx>
          }
          {(bookingData.timeSlot !== undefined && bookingData.timeSlot !== null) &&
            <Colxx xxs={4} className="mb-3">
              <Label>Time Slot</Label>
              <div>
                {bookingData.timeSlot}
              </div>
            </Colxx>
          }
          <Colxx xxs={12} className="mb-3">
            <Label>Comments</Label>
            <div>
              {bookingData.comments}
            </div>
          </Colxx>
          <Colxx xxs={4} className="mb-3">
            <Label>Booking Status</Label>
            <div>{bookingData.bookingStatus}</div>
          </Colxx>
          <Colxx xxs={4} className="mb-3">
            <Label>Payment Status</Label>
            <div>{bookingData.paymentStatus}</div>
          </Colxx>
        </Row>
        <h4>Add-on's</h4>
        {bookingData.addOns.map((addOn, index) => (
          <Row key={index}>
            <Colxx xxs={4} className="mb-3">
              {addOn.name}
            </Colxx>
            <Colxx xxs={4} className="mb-3">
              {addOn.displayText}
            </Colxx>
            <Colxx xxs={4} className="mb-3">
              <div>
                {addOn.currency} {addOn.priceIncTax}
              </div>
            </Colxx>
          </Row>
        ))}

        <h4>Extra</h4>
        {(bookingData.extras != undefined && bookingData.extras.length > 0) && bookingData.extras.map((extra, index) => (
          <Row key={index}>
            <Colxx xxs={4} className="mb-3">
              {extra.name}
            </Colxx>
            <Colxx xxs={4} className="mb-3">
              {extra.displayText}
            </Colxx>
            <Colxx xxs={4} className="mb-3">
              <div>
                {extra.currency} {extra.priceIncTax}
              </div>
            </Colxx>
          </Row>
        ))}
        <h4>Promo</h4>
        {(bookingData.promos != undefined && bookingData.promos.length > 0) && bookingData.promos.map((promo, index) => (
          <Row key={index}>
            <Colxx xxs={4} className="mb-3">
              {promo.type}
            </Colxx>
            <Colxx xxs={4} className="mb-3">
              {promo.name}
            </Colxx>
            <Colxx xxs={4} className="mb-3">
              {promo.conditions}
            </Colxx>
          </Row>
        ))}
        {(bookingData.guests != undefined && bookingData.guests.length > 0) && bookingData.guests.length > 0 && (
          <Fragment>
            <h4>Guest Details</h4>
            <Row className="mb-3">
              {(bookingData.timeSlot == undefined || bookingData.timeSlot == null) &&
                <Fragment>
                  <Colxx xxs={4} className="mb-3">
                    <Label>First Name</Label>
                    <div>{bookingData.guests[0].firstName}</div>
                  </Colxx>
                  <Colxx xxs={4} className="mb-3">
                    <Label>Last Name</Label>
                    <div>{bookingData.guests[0].lastName}</div>
                  </Colxx>
                </Fragment>
              }
              <Colxx xxs={4} className="mb-3">
                <Label>Name</Label>
                <div>{bookingData.guests[0].firstName}</div>
              </Colxx>
              <Colxx xxs={4} className="mb-3">
                <Label>Email</Label>
                <div>{bookingData.guests[0].email}</div>
              </Colxx>
              <Colxx xxs={4} className="mb-3">
                <Label>Mobile Number</Label>
                <div>{bookingData.guests[0].mobileNumber}</div>
              </Colxx>
              <Colxx xxs={8} className="mb-3">
                <Label>Address</Label>
                <div>{bookingData.guests[0].address} {bookingData.guests[0].city} {bookingData.guests[0].state} {bookingData.guests[0].country} {bookingData.guests[0].postcode}</div>
              </Colxx>
            </Row>
          </Fragment>
        )}

      </ModalBody>
      <ModalFooter>
        {bookingData.bookingStatus !== 'Confirmed' && bookingData.bookingStatus !== 'Cancelled' && (<Button color="primary" onClick={() => ConfirmBooking()}>
          Confirm Booking
        </Button>)}

        {bookingData.bookingStatus === 'Confirmed' && (<Button color="primary" onClick={() => toggleCancelBooking()}>
          Cancel Booking
        </Button>)}

        <Button color="secondary" onClick={() => toggle()}>
          Cancel
        </Button>
      </ModalFooter>
      {generateCancelBooking()}
    </Modal>
  );
}
const mapStateToProps = ({ settings }) => {
  const { propertyId, locale } = settings;
  return {
    propertyId, locale
  };
};
export default injectIntl(connect(mapStateToProps)(BookingDetail));
